import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../utils/api";

const Navbar = () => {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === "admin";
  const navigate = useNavigate();
  const [scansToday, setScansToday] = useState(null);

  const getInitials = (email) => {
    if (!email) return "?";
    const parts = email.split("@")[0].split(".");
    return parts.length >= 2 ? (parts[0][0] + parts[1][0]).toUpperCase() : email[0].toUpperCase();
  };

  const displayName = user?.email?.split("@")[0].split(".").map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(" ");

  useEffect(() => {
    if (!user) return;
    const fetchScans = () => {
      api.get("/api/analytics/scans-today").then((res) => setScansToday(res.data.count)).catch(() => {});
    };
    fetchScans();
    const interval = setInterval(fetchScans, 60000); // refresh every minute
    return () => clearInterval(interval);
  }, [user]);

  return (
    <nav className="navbar navbar-expand-lg tl-navbar">
      <div className="container-fluid">
        <NavLink className="navbar-brand" to="/">
          <img src="/assets/scan-loom_top-logo_sm.png" alt="Scan Loom" style={{ height: 32 }} />
        </NavLink>

        <div className="collapse navbar-collapse">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <NavLink className="nav-link" to="/" end>Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/products">Products</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/analytics">Analytics</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/reports">Reports</NavLink>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                Configuration
              </a>
              <ul className="dropdown-menu">
                <li><span className="dropdown-header">LOOKUPS</span></li>
                <li><NavLink className="dropdown-item" to="/settings/retailers">Retailers</NavLink></li>
              </ul>
            </li>
          </ul>

          {/* Scans today counter */}
          {scansToday !== null && (
            <div className="d-flex align-items-center me-3" style={{ cursor: "pointer" }} onClick={() => navigate("/analytics")} title="Scans today (Eastern time)">
              <span style={{ fontSize: "20px", fontWeight: 700, color: "var(--tl-purple-dark)" }}>{scansToday.toLocaleString()}</span>
              <span style={{ fontSize: "10px", color: "var(--tl-text-muted)", marginLeft: "6px", lineHeight: 1.2 }}>scans<br />today</span>
            </div>
          )}

          <div className="dropdown">
            <a className="d-flex align-items-center gap-2 text-decoration-none dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" style={{ color: "var(--tl-text)" }}>
              <div className="tl-avatar">{getInitials(user?.email)}</div>
              <span style={{ fontSize: "13px", fontWeight: 500 }}>{displayName}</span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end">
              <li><span className="dropdown-item disabled" style={{ fontSize: "12px", color: "var(--tl-text-muted)" }}>{user?.email}</span></li>
              <li><span className="dropdown-item disabled" style={{ fontSize: "12px" }}>Role: {user?.role}</span></li>
              {isAdmin && (
                <>
                  <li><hr className="dropdown-divider" /></li>
                  <li><button className="dropdown-item" onClick={() => navigate("/users")}>User Management</button></li>
                </>
              )}
              <li><hr className="dropdown-divider" /></li>
              <li><button className="dropdown-item text-danger" onClick={logout}>Logout</button></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
